import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendSocketMessage } from '../../redux/socketMiddleware';
import { setChatCollapsed } from '../../redux/chatBoxSilce';
import './gameroom.css';

const EMPTY_MESSAGES = [];

const ChatWindow = ({ gameId }) => {
  const dispatch = useDispatch();
  const messages = useSelector(state => state.games.chatMessages[gameId] || EMPTY_MESSAGES);
  const username = useSelector(state => state.playerInfo.username);
  const [input, setInput] = useState('');
  const collapsed = useSelector(state => state.chatBox.collapsed[gameId] ?? false);
  const messagesRef = useRef(null);

  useEffect(() => {
    // Scroll ONLY the message list. scrollIntoView would also scroll every scrollable
    // ancestor — including the overflow-clipped table view, shifting the whole table up.
    const el = messagesRef.current;
    if (!collapsed && el) {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    }
  }, [messages, collapsed]);

  const handleSend = () => {
    const text = input.trim();
    if (!text) return;
    dispatch(sendSocketMessage(`/app/game/${gameId}/chat`, { username, text }));
    setInput('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSend();
  };

  const formatTime = (ts) => {
    const d = new Date(ts);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`chat-window ${collapsed ? 'chat-collapsed' : ''}`}>
      <div className="chat-header" onClick={() => dispatch(setChatCollapsed({ gameId, collapsed: !collapsed }))}>
        <span>Chat</span>
        <span className="chat-toggle">{collapsed ? '▲' : '▼'}</span>
      </div>
      {!collapsed && (
        <>
          <div className="chat-messages" ref={messagesRef}>
            {messages.map((msg, i) => (
              <div key={i} className={`chat-msg ${msg.username === username ? 'chat-msg-mine' : ''}`}>
                <span className="chat-msg-user">{msg.username}</span>
                <span className="chat-msg-text">{msg.text}</span>
                <span className="chat-msg-time">{formatTime(msg.timestamp)}</span>
              </div>
            ))}
          </div>
          <div className="chat-input-row">
            <input
              className="chat-input"
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Message..."
              maxLength={200}
            />
            <button className="chat-send-btn" onClick={handleSend}>Send</button>
          </div>
        </>
      )}
    </div>
  );
};

export default ChatWindow;
